__turbopack_context__.v({
  "heatfindWidget": "AHuZVG_heatfindWidget",
});
